import React from 'react';
import { UserProfile } from "@/hooks/useUsersAdmin";
import { UsersTable } from "./UsersTable";

interface UsersListProps {
  users: UserProfile[];
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onEdit: (user: UserProfile) => void;
  onChangeRole: (userId: string, newRole: string) => void;
  onCommissionUpdated?: () => void;
}

export const UsersList: React.FC<UsersListProps> = ({ 
  users, 
  searchTerm, 
  setSearchTerm,
  onEdit, 
  onChangeRole,
  onCommissionUpdated
}) => {
  return (
    <UsersTable
      users={users}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      onEdit={onEdit}
      onChangeRole={onChangeRole}
      onCommissionUpdated={onCommissionUpdated}
    />
  );
};
